<template>
  <divcard titled>
    <div class="card-part pt-0">
      <div class="txt-head black--text mb-2">
        <span class="theme-color-one">ส่วนที่ 2 :</span> ข้อมูลโครงการ
      </div>

      <!-- Form 1 -->
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview && dataReady"
            :is-correct="partTwoValidate('one')"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            1. ข้อมูลหัวหน้าโครงการและคณะผู้เชี่ยวชาญ
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8 mb-3">
          <!-- Form 1 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">ชื่อ - สกุล</div>
              <div>{{ partTwoForm.s2_p1_name }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">ตำเเหน่ง</div>
              <div>{{ partTwoForm.s2_p1_position }}</div>
            </div>
          </div>

          <!-- Form 1 #line2 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">หน่วยงาน</div>
              <div>{{ partTwoForm.s2_p1_dep }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">สังกัด</div>
              <div>{{ partTwoForm.s2_p1_org }}</div>
            </div>
          </div>

          <!-- Form 1 #line3 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">ที่อยู่</div>
              <div>{{ partTwoForm.s2_p1_addr }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">เบอร์โทรศัพท์</div>
              <div>{{ partTwoForm.s2_p1_phone }}</div>
            </div>
          </div>

          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">E-mail</div>
              <div>{{ partTwoForm.s2_p1_email }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">ความเชี่ยวชาญ</div>
              <div>{{ partTwoForm.s2_p1_expertise }}</div>
            </div>
          </div>

          <!-- Form 1 #line4 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">สัดส่วนการทำงาน</div>
              <div>{{ partTwoForm.s2_p1_resp }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">ชั่วโมงการทำงาน</div>
              <div>{{ partTwoForm.s2_p1_resp_hrs }}</div>
            </div>
          </div>
        </div>

        <!--    Teams    -->
        <div
          v-if="
            partTwoForm.project_teams && partTwoForm.project_teams.length > 0
          "
          class="indent-info mb-3 black--text topic-field font-type-bold"
        >
          ข้อมูลคณะ
        </div>
        <div
          v-for="(team, i) in partTwoForm.project_teams"
          :key="i"
          class="indent-info d-flex flex-column gap-8 mb-3"
        >
          <div class="mb-1 black--text topic-field font-type-bold">
            1.{{ i + 1 }}
          </div>
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">ชื่อ - สกุล</div>
              <div>{{ team.s2_p1_name }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">ตำเเหน่ง</div>
              <div>{{ team.s2_p1_position }}</div>
            </div>
          </div>

          <!-- Form 1 #line2 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">หน่วยงาน</div>
              <div>{{ team.s2_p1_dep }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">สังกัด</div>
              <div>{{ team.s2_p1_org }}</div>
            </div>
          </div>

          <!-- Form 1 #line3 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">ที่อยู่</div>
              <div>{{ team.s2_p1_addr }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">เบอร์โทรศัพท์</div>
              <div>{{ team.s2_p1_phone }}</div>
            </div>
          </div>

          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">E-mail</div>
              <div>{{ team.s2_p1_email }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">ความเชี่ยวชาญ</div>
              <div>{{ team.s2_p1_expertise }}</div>
            </div>
          </div>

          <!-- Form 1 #line4 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">สัดส่วนการทำงาน</div>
              <div>{{ team.s2_p1_resp }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">ชั่วโมงการทำงาน</div>
              <div>{{ team.s2_p1_resp_hrs }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card-part">
      <!-- Form 2 -->
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview && dataReady"
            :is-correct="partTwoValidate('two')"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            2. ผู้รับผิดชอบโครงการ (ภาคเอกชน)
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 2 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">ชื่อ - สกุล</div>
              <div>{{ partTwoForm.s2_p2_pm_name }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">ตำเเหน่ง</div>
              <div>{{ partTwoForm.s2_p2_pm_position }}</div>
            </div>
          </div>

          <!-- Form 2 #line2 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">เบอร์โทรศัพท์</div>
              <div>{{ partTwoForm.s2_p2_pm_phone }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">E-mail</div>
              <div>{{ partTwoForm.s2_p2_pm_email }}</div>
            </div>
          </div>

          <div class="font-type-bold black--text mb-3">
            ข้อมูลประสานงานโครงการ
          </div>

          <!-- Form 2 #line3 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">ชื่อ - สกุล</div>
              <div>{{ partTwoForm.s2_p2_proj_coord_name }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">ตำเเหน่ง</div>
              <div>{{ partTwoForm.s2_p2_proj_coord_position }}</div>
            </div>
          </div>

          <!-- Form 2 #line4 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">เบอร์โทรศัพท์</div>
              <div>{{ partTwoForm.s2_p2_proj_coord_phone }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">E-mail</div>
              <div>{{ partTwoForm.s2_p2_proj_coord_email }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card-part">
      <!-- Form 3 -->
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview && dataReady"
            :is-correct="partTwoValidate('three')"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            3. ข้อมูลภาคเอกชนที่เข้าร่วมโครงการ
            <!--            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 2 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                ชื่อ - สกุล นิติบุคคล/กิจการ
              </div>
              <div>{{ partTwoForm.s2_p3_prv_org_name }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">ที่อยู่</div>
              <div>{{ partTwoForm.s2_p3_prv_org_address }} {{ partTwoForm.s2_p3_addr_sdid?.includes('แขวง') ? '' : 'ตำบล' }} {{ partTwoForm.s2_p3_addr_sdid || '-' }} {{ partTwoForm.s2_p3_addr_sdid?.includes('แขวง') ? 'เขต' : 'อำเภอ' }} {{ partTwoForm.s2_p3_addr_did || '-' }} {{ partTwoForm.s2_p3_addr_sdid?.includes('แขวง') ? '' : 'จังหวัด' }} {{ partTwoForm.s2_p3_addr_pid || '-' }}</div>
            </div>
          </div>

          <!-- Form 2 #line2 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">เบอร์โทรศัพท์</div>
              <div>{{ partTwoForm.s2_p3_prv_org_phone }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">E-mail</div>
              <div>{{ partTwoForm.s2_p3_prv_org_email }}</div>
            </div>
          </div>

          <!-- Form 2 #line3 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                รูปแบบของธุรกิจ/ลักษณะกิจการ (แบบย่อ)
                <!--                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
              </div>
              <div class="pl-10">{{ partTwoForm.s2_p3_prv_org_type }}</div>
            </div>
          </div>

          <!-- Form 2 #line4 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ระบุแนวโน้มที่บริษัทจะเป็นผู้เช่าพื้นที่ในอุทยานวิทยาศาสตร์ภูมิภาคในอนาคต
                <!--                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
              </div>
              <div
                class="pl-10"
                v-html="partTwoForm.s2_p3_prv_org_trend?.replace(/\n/g, '<br>')"
              ></div>
            </div>
          </div>

          <!-- Form 2 #line5 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-3 black--text">
                สัดส่วนการลงทุนของเอกชนในการร่วมโครงการ
                <span class="theme-color-seven txt-normal"
                  >(ข้อมูลมาจากส่วนที่3)</span
                >
              </div>

              <div>
                <ul>
                  <li>
                    <div class="d-flex justify-space-between" style="gap: 16px">
                      <div class="black--text pt-2">ภาคเอกชนสนับสนุนจำนวน</div>
                      <div class="d-flex justify-end" style="gap: 16px">
                        <div class="pt-2">
                          {{ formatNumber(private_sum, 2) }}
                        </div>
                        <div class="black--text pt-2">บาท</div>
                        <div
                          class="black--text pt-2"
                          style="min-width: 80px; max-width: 80px"
                        >
                          โดยแบ่งเป็น
                        </div>
                        <div style="min-width: 200px; max-width: 200px"></div>
                      </div>
                    </div>

                    <ul style="list-style: none">
                      <li>
                        <div
                          class="d-flex justify-space-between"
                          style="gap: 16px"
                        >
                          <div class="pt-2">
                            ส่วนที่เป็นตัวเงิน(In-cash)จำนวน
                          </div>
                          <div
                            class="pt-2 d-flex justify-end"
                            style="gap: 16px"
                          >
                            <div class="pt-2">
                              {{ formatNumber(incash_sum, 2) }}
                            </div>
                            <div class="pt-2">บาท</div>
                            <div
                              class="pt-2"
                              style="min-width: 80px; max-width: 80px"
                            >
                              คิดเป็นร้อยละ
                            </div>
                            <div class="pt-2">{{ incash_percent }}</div>
                            <div
                              style="min-width: 200px; max-width: 200px"
                            ></div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          class="d-flex justify-space-between"
                          style="gap: 16px"
                        >
                          <div class="pt-2">
                            ส่วนที่เป็นสิ่งของสนับสนุน(In-Kind)จำนวน
                          </div>
                          <div
                            class="pt-2 d-flex justify-end"
                            style="gap: 16px"
                          >
                            <div class="pt-2">
                              {{ formatNumber(inkind_sum, 2) }}
                            </div>
                            <div class="pt-2">บาท</div>
                            <div
                              class="pt-2"
                              style="min-width: 80px; max-width: 80px"
                            >
                              คิดเป็นร้อยละ
                            </div>
                            <div class="pt-2">{{ inkind_percent }}</div>
                            <div
                              style="min-width: 200px; max-width: 200px"
                            ></div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <div class="d-flex justify-space-between" style="gap: 16px">
                      <div class="black--text pt-2">
                        อุทยานวิทยาศาสตร์ภูมิภาค สนับสนุนจำนวน
                      </div>
                      <div class="d-flex justify-end" style="gap: 16px">
                        <div class="pt-2">
                          {{ formatNumber(scipark_sum, 2) }}
                        </div>
                        <div class="black--text pt-2">บาท</div>
                        <div
                          class="black--text pt-2"
                          style="min-width: 80px; max-width: 80px"
                        >
                          คิดเป็นร้อยละ
                        </div>
                        <div class="pt-2">{{ scipark_percent }}</div>
                        <div style="min-width: 200px; max-width: 200px"></div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!isFinal" class="card-part">
      <!-- Form 4 -->
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview && dataReady"
            :is-correct="partTwoValidate('four')"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            4.
            กิจการของภาคเอกชนที่เข้าร่วมโครงการมีความเกี่ยวข้องในกลุ่มอุตสาหกรรม
            <!--            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 4 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div
                v-html="
                  Array.isArray(partTwoForm.s2_p4_prv_org_involved)
                    ? partTwoForm.s2_p4_prv_org_involved.join(', <br>')
                    : ''
                "
              ></div>
            </div>
          </div>
          <!-- Form 4 #line2 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div>
                <b>ระบุเพิ่มเติม:</b>
                {{
                  partTwoForm.s2_p4_prv_org_other
                    ? partTwoForm.s2_p4_prv_org_other
                    : "-"
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
   <div v-if="!isFinal" class="card-part">
      <!-- Form 11 -->
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview && dataReady"
            :is-correct="partTwoValidate('eleven')"
          ></ValidatorIcon>
          <div class="flex xs6 d-flex gap-16">
            <div class="font-type-bold black--text">5. หลักการและเหตุผล</div>
            <div
              v-html="partTwoForm.s2_p11_principle?.replace(/\n/g, '<br>')"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isFinal" class="card-part">
      <!-- Form 12 -->
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview && dataReady"
            :is-correct="partTwoValidate('twelve')"
          ></ValidatorIcon>
          <div class="flex xs6 d-flex gap-16">
            <div class="font-type-bold black--text">
               6. วัตถุประสงค์
            </div>
            <div
              v-html="partTwoForm.s2_p12_objective?.replace(/\n/g, '<br>')"
            ></div>
          </div>
        </div>
      </div>
    </div>
<div v-if="!isFinal" class="card-part">
      <!-- Form 6 -->
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview && dataReady"
            :is-correct="partTwoValidate('six')"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            7. ระบุปัญหาหรือความต้องการของภาคเอกชน
            <!--            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 6 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div
                v-html="
                  partTwoForm.s2_p6_prv_org_issue_desc?.replace(/\n/g, '<br>')
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isFinal" class="card-part">
      <!-- Form 5 -->
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview && dataReady"
            :is-correct="partTwoValidate('five')"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            8. กิจการของภาคเอกชน ได้รับการแก้ไขปัญหาด้านใดจากการเข้าร่วมโครงการ
            <div class="theme-color-seven txt-normal">
              อธิบายในหัวข้อที่ตรงกับกิจการของภาคเอกชนที่ได้รับการแก้ไขปัญหา
              (ตอบได้มากกว่า 1 ข้อ)
            </div>
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 5 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">พัฒนาคุณภาพสินค้าให้ได้มาตรฐาน</div>
              <div
                class="pl-10"
                v-html="
                  partTwoForm.s2_p5_prv_org_impr_product_quality?.replace(
                    /\n/g,
                    '<br>'
                  )
                "
              ></div>
            </div>
          </div>
          <!-- Form 5 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">การแก้ไขปัญหาของกระบวนการผลิต</div>
              <div
                class="pl-10"
                v-html="
                  partTwoForm.s2_p5_prv_org_impr_process_issue?.replace(
                    /\n/g,
                    '<br>'
                  )
                "
              ></div>
            </div>
          </div>

          <!-- Form 5 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การปรับปรุงประสิทธิภาพกระบวนการผลิต
              </div>
              <div
                class="pl-10"
                v-html="
                  partTwoForm.s2_p5_prv_org_impr_process_eff?.replace(
                    /\n/g,
                    '<br>'
                  )
                "
              ></div>
            </div>
          </div>

          <!-- Form 5 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">การพัฒนาผลิตภัณฑ์ใหม่</div>
              <div
                class="pl-10"
                v-html="
                  partTwoForm.s2_p5_prv_org_impr_new_product?.replace(
                    /\n/g,
                    '<br>'
                  )
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    

    <div v-if="!isFinal" class="card-part">
      <!-- Form 7 -->
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview && dataReady"
            :is-correct="partTwoValidate('seven')"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            9. เทคโนโลยี นวัตกรรม เเละการพัฒนาด้านใดที่นำมาใช้ในการเเก้ไขปัญหาให้กับภาคเอกชน
            <!--            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 7 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div
                v-html="partTwoForm.s2_p7_inno_desc?.replace(/\n/g, '<br>')"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!isFinal" class="card-part">
      <!-- Form 8 -->
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview && dataReady"
            :is-correct="partTwoValidate('eight')"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            10. ศักยภาพและความพร้อมในการดำเนินโครงการของภาคเอกชน
            <!--            <span class="theme-color-seven txt-normal">(โปรดกรอกข้อมูลให้ครบทุกข้อ)</span>-->
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 8 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ศักยภาพความพร้อมในการทำงานวิจัยและพัฒนา
              </div>
            </div>
          </div>
          <!-- Form 8 #line2 -->
          <div class="flex-center gap-16 pl-10">
            <div class="flex">
              <div class="mb-1 black--text">
                มีความรู้พื้นฐานด้านเทคโนโลยีที่
                เกี่ยวข้องกับผลิตภัณฑ์และกระบวนการ
              </div>
              <div
                class="pl-10"
                v-html="
                  partTwoForm.s2_p8_prv_org_project_readiness?.replace(
                    /\n/g,
                    '<br>'
                  )
                "
              ></div>
            </div>
          </div>
          <!-- Form 8 #line3 -->
          <div class="flex-center gap-16 pl-10">
            <div class="flex">
              <div class="mb-1 black--text">
                ความพร้อมด้านอุปกรณ์ เครื่องมือ ในการทำงานวิจัย
              </div>
              <div
                class="pl-10"
                v-html="
                  partTwoForm.s2_p8_prv_org_rnd_readiness?.replace(
                    /\n/g,
                    '<br>'
                  )
                "
              ></div>
            </div>
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 8 #line4 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">ความพร้อมด้านการเงิน</div>
              <div
                class="pl-10"
                v-html="
                  partTwoForm.s2_p8_prv_org_financial_readiness?.replace(
                    /\n/g,
                    '<br>'
                  )
                "
              ></div>
            </div>
          </div>
        </div>
        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 8 #line4 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การบริหารจัดการองค์กรและบุคลากร
              </div>
              <div
                class="pl-10"
                v-html="
                  partTwoForm.s2_p8_prv_org_mgmt_readiness?.replace(
                    /\n/g,
                    '<br>'
                  )
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!isFinal" class="card-part">
      <!-- Form 9 -->
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview && dataReady"
            :is-correct="partTwoValidate('nine')"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            11. ศักยภาพและความพร้อมในการดำเนินโครงการของอุทยานวิทยาศาสตร์ภูมิภาค
            <!--            <div class="theme-color-seven txt-normal">-->
            <!--              (โปรดกรอกข้อมูลให้ครบทุกข้อ)-->
            <!--            </div>-->
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 9 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ความพร้อมของบุคลากรและผู้เชี่ยวชาญ
                ประสบการณ์การทำงานร่วมกับภาคอุตสาหกรรม
              </div>
              <div
                class="pl-10"
                v-html="
                  partTwoForm.s2_p9_personnel_expertise?.replace(/\n/g, '<br>')
                "
              ></div>
            </div>
          </div>
          <!-- Form 9 #line2 -->
          <div v-if="!isFinal" class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ความพร้อมของห้องปฏิบัติการ
                เครื่องมืออุปกรณ์ทางวิทยาศาสตร์และสิ่งอำนวยความสะดวก
              </div>
              <div
                class="pl-10"
                v-html="
                  partTwoForm.s2_p9_lab_eqt_readiness?.replace(/\n/g, '<br>')
                "
              ></div>
            </div>
          </div>

          <!-- Form 9 #line3 -->
          <div v-if="!isFinal" class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                องค์ความรู้พื้นฐานที่จะช่วยสนับสนุนการแก้โจทย์จากภาคเอกชน
              </div>
              <div
                class="pl-10"
                v-html="
                  partTwoForm.s2_p9_knowledge_readiness?.replace(/\n/g, '<br>')
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!isFinal" class="card-part">
      <!-- Form 10 -->
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview && dataReady"
            :is-correct="partTwoValidate('ten')"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            12. ขั้นตอนและขอบเขตการดำเนินโครงการ
            <!--            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 10 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div
                v-html="
                  partTwoForm.s2_p10_project_scope_detail?.replace(
                    /\n/g,
                    '<br>'
                  )
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div v-if="isFinal" class="card-part">
      <!-- Form 12 -->
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview && dataReady"
            :is-correct="partTwoValidate('twelve')"
          ></ValidatorIcon>
          <div class="flex xs6 d-flex gap-16">
            <div class="font-type-bold black--text">
              {{ isFinal ? "4." : "12." }} วัตถุประสงค์
            </div>
            <div
              v-html="partTwoForm.s2_p12_objective?.replace(/\n/g, '<br>')"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isFinal" class="card-part">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview && dataReady"
            :is-correct="partTwoForm.s2_source"
          ></ValidatorIcon>
          <div class="font-type-bold black--text">5. ที่มาและความสำคัญ</div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.s2_source?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isFinal" class="card-part">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview && dataReady"
            :is-correct="partTwoForm.s2_industry_type"
          ></ValidatorIcon>
          <div class="font-type-bold black--text">
            6. ประเภทอุตสาหกรรม
            <!--            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div
                v-html="partTwoForm.s2_industry_type?.replace(/\n/g, '<br>')"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isFinal" class="card-part">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview && dataReady"
            :is-correct="partTwoForm.s2_apply_type"
          ></ValidatorIcon>
          <div class="font-type-bold black--text">
            7. รูปแบบการเข้าร่วมโครงการเพื่อรับบริการ
            <!--            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div
                v-html="
                  partTwoForm.s2_apply_type
                    ? partTwoForm.s2_apply_type.join(', <br>')
                    : ''
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isFinal" class="card-part">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview && dataReady"
            :is-correct="partTwoForm.s2_overall_result"
          ></ValidatorIcon>
          <div class="font-type-bold black--text">
            8. ผลการดำเนินงาน
            <!--            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div
                v-html="partTwoForm.s2_overall_result?.replace(/\n/g, '<br>')"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isFinal" class="card-part">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview && dataReady"
            :is-correct="partTwoForm.s2_summary_operation_detail"
          ></ValidatorIcon>
          <div class="font-type-bold black--text">
            9. สรุปรายละเอียดแผนการดำเนินงาน / กิจกรรมหลัก
            <!--            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div
                v-html="
                  partTwoForm.s2_summary_operation_detail?.replace(
                    /\n/g,
                    '<br>'
                  )
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isFinal" class="card-part">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview && dataReady"
            :is-correct="partTwoForm.s2_interest"
          ></ValidatorIcon>
          <div class="font-type-bold black--text">
            10. ความสนใจในการใช้บริการอื่นๆของอุทยานวิทยาศาสตร์ภูมิภาคในอนาคต
            <!--            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div
                v-html="
                  partTwoForm.s2_interest
                    ? partTwoForm.s2_interest.join(', <br>')
                    : ''
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </divcard>
</template>

<script>
import TextField from "../../../../components/input/TextField";
import SwitchInset from ".././../../../components/input/SwitchInset";
import AutoBox from "../../../../components/input/AutoBox";
import { eventBus, formatNumber, validateEmail } from "@/plugins/global-funcs";
import { mapState } from "vuex";
import OOILineField from "../../../../components/OOILineField";
import ValidatorIcon from "../../../../components/ValidatorIcon";
import { format } from "date-fns";
import { th } from "date-fns/locale";

export default {
  name: "CFormSummary_IRTC",
  components: {
    TextField,
    SwitchInset,
    AutoBox,
    OOILineField,
    ValidatorIcon,
  },
  props: {
    data: {
      default: () => ({}),
    },
    masterData: {
      default: () => ({}),
    },
    budgetList: {
      default: () => [],
    },
    isSameId: {
      default: false,
    },
  },
  data() {
    return {
      formatNumber,
      private_sum: null,
      inkind_sum: null,
      incash_sum: null,
      scipark_sum: null,
      inkind_percent: null,
      incash_percent: null,
      scipark_percent: null,
      partOneForm: {},
      partTwoForm: {},
      shortMonths: [],
      partThreeForm: {},
      partThreeAllPlans: [],
      partThreeBudgetPlans: [],
      partThreeBudgetList: [],
      partThreeAllProgressPlan: [],
      kpi: {},
      partFiveAttachment: [],
      ableToSubmit: true,
      dataReady: false
    };
  },
  computed: {
    ...mapState({
      // GeneralForm: state => state.CForm.GeneralForm,
      // ProjectForm: state => state.CForm.ProjectForm,
      // PlanForm: state => state.CForm.PlanForm,
      // OOIForm: state => state.CForm.OOIForm,
      // AttachmentForm: state => state.CForm.AttachmentForm,
      SummaryData: (state) => state.CForm.SummaryData,
    }),
    isFinal() {
      return (
        this.$route.query.doc_type && this.$route.query.doc_type === "progress"
      );
    },
  },
  async created() {
    this.partTwoForm = this.data;
    this.calculateBudgetProportion();
    this.dataReady = true
  },
  methods: {
    allowFormAbleSubmit(isCorrect) {
      if (!isCorrect && this.dataReady) {
        this.ableToSubmit = false;
      }
      eventBus.$emit("CFormPlanAbleToSubmit", this.ableToSubmit);
    },
    partTwoValidate(section) {
      let isCorrect = true;
      switch (section) {
        case "one":
          if (
            !this.partTwoForm.s2_p1_name ||
            !this.partTwoForm.s2_p1_position ||
            !this.partTwoForm.s2_p1_dep ||
            !this.partTwoForm.s2_p1_org ||
            !this.partTwoForm.s2_p1_addr ||
            !this.partTwoForm.s2_p1_expertise ||
            !this.partTwoForm.s2_p1_resp
          ) {
            isCorrect = false;
          }

          if (!this.partTwoForm.s2_p1_phone) {
            isCorrect = false;
          }

          if (!validateEmail(this.partTwoForm.s2_p1_email)) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "two":
          if (
            !this.partTwoForm.s2_p2_pm_name ||
            !this.partTwoForm.s2_p2_pm_position ||
            !this.partTwoForm.s2_p2_pm_phone ||
            !this.partTwoForm.s2_p2_pm_email ||
            !this.partTwoForm.s2_p2_proj_coord_name ||
            !this.partTwoForm.s2_p2_proj_coord_position ||
            !this.partTwoForm.s2_p2_proj_coord_phone ||
            !this.partTwoForm.s2_p2_proj_coord_email
          ) {
            isCorrect = false;
          }

          if (
            !this.partTwoForm.s2_p2_pm_phone ||
            !this.partTwoForm.s2_p2_proj_coord_phone) {
            isCorrect = false;
          }

          if (
            !validateEmail(this.partTwoForm.s2_p2_pm_email) ||
            !validateEmail(this.partTwoForm.s2_p2_proj_coord_email)
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "three":
          if (
            !this.partTwoForm.s2_p3_prv_org_name ||
            !this.partTwoForm.s2_p3_prv_org_address ||
            !this.partTwoForm.s2_p3_prv_org_phone ||
            !this.partTwoForm.s2_p3_prv_org_email ||
            !this.partTwoForm.s2_p3_prv_org_type ||
            !this.partTwoForm.s2_p3_prv_org_trend
          ) {
            isCorrect = false;
          }

          if (!this.partTwoForm.s2_p3_prv_org_phone) {
            isCorrect = false;
          }

          if (!validateEmail(this.partTwoForm.s2_p3_prv_org_email)) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "four":
          if (!this.partTwoForm.s2_p4_prv_org_involved) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "five":
          if (
            !this.partTwoForm.s2_p5_prv_org_impr_product_quality ||
            !this.partTwoForm.s2_p5_prv_org_impr_process_issue ||
            !this.partTwoForm.s2_p5_prv_org_impr_process_eff ||
            !this.partTwoForm.s2_p5_prv_org_impr_new_product
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "six":
          if (!this.partTwoForm.s2_p6_prv_org_issue_desc) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "seven":
          if (!this.partTwoForm.s2_p7_inno_desc) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "eight":
          if (
            !this.partTwoForm.s2_p8_prv_org_project_readiness ||
            !this.partTwoForm.s2_p8_prv_org_rnd_readiness ||
            !this.partTwoForm.s2_p8_prv_org_financial_readiness ||
            !this.partTwoForm.s2_p8_prv_org_mgmt_readiness
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "nine":
          if (
            !this.partTwoForm.s2_p9_personnel_expertise ||
            !this.partTwoForm.s2_p9_lab_eqt_readiness ||
            !this.partTwoForm.s2_p9_knowledge_readiness
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "ten":
          if (!this.partTwoForm.s2_p10_project_scope_detail) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "eleven":
          if (!this.partTwoForm.s2_p11_principle) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "twelve":
          if (!this.partTwoForm.s2_p12_objective) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;
      }
    },
    calculateBudgetProportion() {
      let budgetList = this.budgetList;

      if (budgetList !== undefined && budgetList.length > 0) {
        let all_sum = budgetList
          .map((x) => x.budget_sum)
          .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
        this.inkind_sum = budgetList
          .map((x) => x.budget_in_kind)
          .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
        this.incash_sum = budgetList
          .map((x) => x.budget_in_cash)
          .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
        this.private_sum = this.inkind_sum + this.incash_sum;
        this.scipark_sum = budgetList
          .map((x) => x.budget_sci_park)
          .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
        this.inkind_percent = ((this.inkind_sum * 100) / all_sum).toFixed(2);
        this.incash_percent = ((this.incash_sum * 100) / all_sum).toFixed(2);
        this.scipark_percent = ((this.scipark_sum * 100) / all_sum).toFixed(2);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.budget-item,
.summary-plan {
  background: #ffffff;
  box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  padding: 12px;
}

.summary-plan {
  min-height: 78px;
}

.remark-box {
  color: var(--theme-color-seven);
  background: #fafafa;
  border-radius: 20px;
  padding: 12px;
  font-size: 10px;
}

.plan-card {
  background: #ffffff;
  box-shadow: 1px 1px 18px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  border: 1px solid transparent;
  padding: 12px;
  min-width: max-content;
  &.plan-active {
    border: 1px solid var(--theme-color-seven);
  }
}

.plan-field-form {
  /* User input values. */
  --grid-layout-gap: 16px;
  --grid-column-count: 6;
  --grid-item--min-width: 130px;

  /* Calculated values. */
  --gap-count: calc(var(--grid-column-count) - 1);
  --total-gap-width: calc(var(--gap-count) * var(--grid-layout-gap));
  --grid-item--max-width: calc(
    (100% - var(--total-gap-width)) / var(--grid-column-count)
  );

  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(max(var(--grid-item--min-width), var(--grid-item--max-width)), 1fr)
  );
  grid-gap: var(--grid-layout-gap);
}

.plan-slot > div {
  transition: background-color 400ms;
  background-color: #fff;
  height: 20px;
}
.plan-slot .progress-plan-mark {
  background-color: var(--theme-color-one);
  min-width: 45px;
  display: flex;
  align-items: center;
  padding-top: 1px;
  .v-divider {
    border-color: #fff;
  }
}

.progress-plan-mark.start-point {
  border-radius: 30px 0 0 30px;
  padding-left: 4px;
}

.progress-plan-mark.end-point {
  border-radius: 0 30px 30px 0;
  padding-right: 6px;
}

.arrow-right {
  display: none;
}
.end-point .arrow-right {
  display: unset;
  font-family: "Tahoma", sans-serif;
  margin-left: -8px;
  margin-top: -3px;
  user-select: none;
}
.topic-field {
  min-width: 160px;
  max-width: 160px;
}
.indent-info {
  padding-left: 85px;
}
</style>
